/*
 * Copyright 2025 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package analytics

data class CategoryTrend(
    val category: String = "",
    val currentAmount: Double = 0.0,
    val projectedAmount: Double = 0.0,
    val trendDirection: String = "stable",
    val confidence: Double = 0.0,
    val trend: String = "stable",
    // New fields for spending increase tracking
    val currentMonthly: Double = currentAmount, // Alias for compatibility
    val forecastedMonthly: Double = projectedAmount, // Alias for compatibility
    val increaseAmount: Double = projectedAmount - currentAmount,
    val increasePercent: Double =
        when {
            currentAmount > 0 -> ((projectedAmount - currentAmount) / currentAmount) * 100
            projectedAmount > 0 -> 100.0 // If going from 0 to something, that's 100%+ increase
            else -> 0.0 // Both are 0, no change
        },
    val isSignificant: Boolean = increasePercent >= 5.0,
)
